module.exports = __webpack_public_path__ + "media/images/icon__arrow-left@2x-51b2ab7e4dc09eaa90c358d217411b54.png";